import React, { useState, useCallback } from 'react';
import { IspmProvider } from './IspmContext';
import { Alert, Icons } from '@silverfort/sf-components';
import SpecificInsightDrawer from './SpecificInsightDrawer/SpecificInsightDrawer';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import IspmHeader from './Header/IspmHeader';
import IspmDashboard from './Dashboard/IspmDashboard';
import InsightsTable from './InsightsTable/InsightsTable';
import InsightsTableFilter from './InsightsTableFilters/InsightsTableFilter';
import ExposuresConfigurationPage from './ExposuresConfiguration/components/ExposuresConfigurationPage';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import useGetExposuresConfigurations from './api/queries/useGetExposuresConfigurations';

const IspmPage = () => {
    const { exposuresConfigurations, refetch, isFetching } = useGetExposuresConfigurations();
    const [showExposuresConfiguration, setShowExposuresConfiguration] = useState(false);

    const openExposuresConfiguration = () => {
        setShowExposuresConfiguration(true);
    };

    const returnToMainPage = useCallback(() => {
        setShowExposuresConfiguration(false);
    }, [setShowExposuresConfiguration]);

    return (
        <PageWrapper icon={Icons.IdentitySearch} title="Active Directory Identity Security Posture Management (ISPM)">
            <Alert />

            <LocalizationProvider dateAdapter={AdapterMoment}>
                <IspmProvider>
                    <SpecificInsightDrawer
                        exposuresConfigurations={exposuresConfigurations ?? []}
                        refetchSettings={refetch}
                    />

                    {!showExposuresConfiguration ? (
                        <div className="flex flex-col gap-4 p-6 w-full h-full">
                            <IspmHeader onCustomizationClick={openExposuresConfiguration} />
                            <IspmDashboard />
                            <InsightsTableFilter />
                            <InsightsTable />
                        </div>
                    ) : (
                        <ExposuresConfigurationPage
                            onBackClick={returnToMainPage}
                            exposuresConfigurations={exposuresConfigurations ?? []}
                            refetchSettings={refetch}
                            isFetching={isFetching}
                        />
                    )}
                </IspmProvider>
            </LocalizationProvider>
        </PageWrapper>
    );
};

export default IspmPage;
